import dayjs from 'dayjs'
import { ViewModel } from './_vm'
import DatePickerTemplate from './_datePickerTemplate'
import ConfigForm from './service/_config'
import FormStore from './store/_form-store'
import { dateFormat, objectToGet } from '../functions/index'
import closingDay from '../const/_closing-day'
/**
 * DatePicker // datePicker描写のjs
 *
 * @returns {undefined}
 */
export class DatePicker extends ViewModel {
  constructor($element, controller) {
    super(DatePicker.name(), $element, controller)

    const direct_config = ConfigForm.init()
    if (direct_config.departureDate === undefined) {
      const cDay = objectToGet(closingDay, '0.day', 14)
      direct_config.departureDate = dayjs().add(cDay, 'day')
    } else {
      direct_config.departureDate = dayjs(dateFormat(direct_config.departureDate, 'YYYY-MM-DD'))
    }

    // 年と月の初期化
    this.formName = this.attr('data-name', 'datePicker')
    this.$text = this.$element.find('.datePicker__dateText')
    this.$body = this.$element.find('.datePicker__calendarWap')
    this.$display = this.$element.find('.selectday')
    this.class = 'datePicker--show'

    // イベントの登録
    this.on(`dateUndecided`, () => this.changeDisplay())
    this.on(`datePicker:render`, () => this.render())
    this.$element.find('.js-date-picker-target').on('click', () => this.show())
    this.selectDate = direct_config.departureDate
    this.calendarDate = direct_config.departureDate

    // 最安値カレンダーのデータを取得
    this.render()
  }

  static name() {
    return 'DatePicker'
  }

  static className() {
    return '.js-kaigai-date-picker'
  }

  changeDisplay() {
    if ($('#NTA_date_undecided-check').prop('checked')) this.$display.css('background-color', '#A0A0A0')
    else this.$display.css('background-color', '')
  }

  show() {
    if (!$('#NTA_date_undecided-check').prop('checked')) this.$element.addClass(this.class)
  }

  close() {
    this.$element.removeClass(this.class)
  }

  init() {
    // イベントの初期化
    this.$element.find('.js-date-picker-select-dey').on('click', event => this.selectDey($(event.currentTarget)))

    this.$element.find('.js-date-picker-select-month').on('click', event => this.selectMonth($(event.currentTarget)))
  }

  selectMonth(event) {
    const year = Number(event.attr('data-year'))
    const month = Number(event.attr('data-month'))
    const day = this.calendarDate.date()
    this.calendarDate = dayjs(`${year}-${month}-${day}`)
    this.render()
  }

  /**
   * selectDey // 日付の選択
   *
   * @param {} event
   */
  selectDey(event) {
    const date = dayjs(event.attr('data-day'))
    this.selectDate = date
    FormStore.formInput(this.formName, date.format('YYYY-MM-DD'))
    this.render()
    this.close()
    this.trigger('tourSearch:nowSelect')
  }

  render() {
    this.$body.empty()
    const html = DatePickerTemplate.render(this.calendarDate, this.selectDate, this.regulationDate)
    this.$body.append(html)

    this.$text.empty()
    this.$text.append(this.selectDate.format('YYYY年MM月DD日'))

    this.init()
  }
}
